import { render, staticRenderFns } from "./mwbjNavbar.vue?vue&type=template&id=0586c622&scoped=true&"
import script from "./mwbjNavbar.vue?vue&type=script&lang=js&"
export * from "./mwbjNavbar.vue?vue&type=script&lang=js&"
import style0 from "./mwbjNavbar.vue?vue&type=style&index=0&id=0586c622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586c622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0586c622')) {
      api.createRecord('0586c622', component.options)
    } else {
      api.reload('0586c622', component.options)
    }
    module.hot.accept("./mwbjNavbar.vue?vue&type=template&id=0586c622&scoped=true&", function () {
      api.rerender('0586c622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/mwbjNavbar.vue"
export default component.exports